export function buildPortfolioCardTestId(code, id) {
    const raw = code?.trim() || id;
    return raw.replace(/[^a-zA-Z0-9]+/g, '');
}
